import {Box} from "@mui/material";
import {useEffect, useState} from "react";

const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isMobile;
};

const getVideoStyles = (isMobile, customMobileStyles = {}) => {
    const defaultStyles = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: 'translate(-50%, -50%)',
        height: "100%",
        objectFit: "cover",
        zIndex: -1,
        // marginLeft: '10%'
    };

    return {
        ...defaultStyles,
        ...(isMobile ? customMobileStyles : {transform: "translate(-50%, -50%)", width: '101%'}),
    };
};

const VideoComponent = ({background, backgroundVideo, customMobileStyles}) => {
    const isMobile = useIsMobile();

    return (
        <Box>
            <video
                autoPlay
                loop
                muted
                playsInline
                webkit-playsinline
                // poster={background}
                style={getVideoStyles(isMobile, customMobileStyles)}
            >
                <source src={backgroundVideo} type="video/mp4"/>
            </video>
        </Box>
    );
};

export default VideoComponent;
